import { AppState } from '../../init/rootReducer';
import { AlphaPageState } from './reducer';

const getAlphaPageState = (state: AppState): AlphaPageState => state.containers.alphaPage;

export default getAlphaPageState;
